import React from 'react';
import TramoViaje from './tramo';
import './paquete-detalle-transporte.css';

const Transporte = (props) => (
  <div className='seccion'>
    <div className='panel panel-default custom bordeado vuelos'>
      <div className='panel-body'>
        <div className='row'>
          <div className='col-xs-12'>
            <b>
              Empresa:
              {props.salida.transporte.transporteAereo == null ? props.salida.transporte.nombreLineaAerea : props.salida.transporte.transporteAereo.nombreLineaAerea}
            </b>
            {props.salida.transporte.transporteAereo == null || props.salida.transporte == null || props.origen == null || props.destino == null ? '' : (
              <TramoViaje
                titulo='Ida'
                origen={props.origen}
                destino={props.destino}
                fecha={props.salida.fechaSalida}
                transporte={props.salida.transporte.transporteAereo}
              />
            ) }
          </div>
          <div className='col-xs-12'>
            {props.salida.transporte.transporteAereo == null || props.salida.transporte == null || props.origen == null || props.destino == null ? '' : (
              <TramoViaje
                titulo='Vuelta'
                origen={props.destino}
                destino={props.origen}
                fecha={props.salida.fechaLlegada}
                transporte={props.salida.transporte.transporteAereo}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  </div>
);
export default Transporte;
